import { useRouter } from 'next/router';
import { ForSaleFilters } from './ForSaleFilters';
import { ToRentFilters } from './ToRentFilters';

const filters = {
    'for-sale': ForSaleFilters,
    'to-rent': ToRentFilters,
    'new-homes': ForSaleFilters
};

const getFiltersComponent = (path: string) => {
    const pathRegex = /for-sale|to-rent|new-homes/;

    const searchType = path.match(pathRegex);

    if (searchType) {
        return filters[searchType[0] as keyof typeof filters];
    }

    return filters['for-sale'];
};

type FiltersProps = {
    onClose: () => void;
    onUpdate: () => void;
};

export const Filters = ({ onClose, onUpdate }: FiltersProps) => {
    const { pathname } = useRouter();

    const Component = getFiltersComponent(pathname);

    return <Component onClose={onClose} onUpdate={onUpdate} />;
};
